import React, { useEffect, useState ,useRef } from 'react';
import getDecryptData from '../../helpers/getDecryptData';
import toast from 'react-hot-toast';
import axiosInstance from '../../axiosInstance';
import { Link,useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../fetchdata/ThemeContext';

const LiveVideoCall = () => {
  const navigate = useNavigate();

   const dragRef = useRef(null);
  const pos = useRef({ x: 0, y: 0, offsetX: 0, offsetY: 0 });

  const onMouseDown = (e) => {
    e.preventDefault();
    pos.current.offsetX = e.clientX;
    pos.current.offsetY = e.clientY;

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    e.preventDefault();

    const dx = e.clientX - pos.current.offsetX;
    const dy = e.clientY - pos.current.offsetY;

    const element = dragRef.current;
    element.style.top = element.offsetTop + dy + 'px';
    element.style.left = element.offsetLeft + dx + 'px';

    pos.current.offsetX = e.clientX;
    pos.current.offsetY = e.clientY;
  };

  const onMouseUp = () => {
    document.removeEventListener('mouseup', onMouseUp);
    document.removeEventListener('mousemove', onMouseMove);
  };

  
    
    const handleEndVideo = async (videoid) => {
    const mydata = {
        orderId: videoid,
    };
  
    try {
      // Wrapping the API call in toast.promise properly
      const response = await toast.promise(
        axiosInstance.post("/admin/end-video-call", mydata), {
          loading: "Ending video call...", // Loading message
          success: "Ending video call successfully!", // Success message
          error: "Failed to Ending video call.", // Error message
        }
      );
  
      console.log('Response:', response);
  
      const { success,video } = response.data;
      if (success) {
        navigate(`/all-video-call`);
      }
  
    } catch (error) {
      console.error('Error starting video call:', error);
    }
  };


 



  const decryptdatajson = getDecryptData();
  const DriverId = decryptdatajson._id;
  const { VideoAllCall,dataAuth } = useThemeContext();

  const [MyData, setMyData] = useState([]);
  const [timeStamps, setTimeStamps] = useState({});

  useEffect(() => {
    if (VideoAllCall && VideoAllCall.length !== 0) {
      setMyData(VideoAllCall);
     }
          console.log('videoAllCall',VideoAllCall);

  }, [VideoAllCall,dataAuth]);

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimes = {};
      MyData.forEach(order => {
        if (order.start && !order.end) {
          const start = new Date(order.start);
          const now = new Date();
          const diff = Math.floor((now - start) / 1000);

          const hrs = String(Math.floor(diff / 3600)).padStart(2, '0');
          const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
          const secs = String(diff % 60).padStart(2, '0');

          updatedTimes[order._id] = `${hrs}:${mins}:${secs}`;
        }
      });
      setTimeStamps(updatedTimes);
    }, 1000);

    return () => clearInterval(interval);
  }, [MyData]);

  return (
    <>
       {MyData && MyData.length !== 0 && (
        <div className='position-absolute end-0 '  style={{zIndex:999999}} ref={dragRef}
      onMouseDown={onMouseDown} >
          
          {MyData.map((data, index) => (
            <div
              className="bg-dark rounded p-3 my-2 d-inline-block rounded-pill border"
              style={{ width: '350px' ,cursor:"grab"}}
              
              key={index}
            >

              <div className="d-flex align-items-center gap-2 justify-content-between">


               <div className="d-flex  text-white  align-items-center gap-2 justify-content-between">
                <i className="bi bi-camera-video-fill d-inline-block"/>
                  <h2 className="display-6 fw-bold text-center m-0  gap-2" style={{width:80}}>
            {timeStamps[data._id] || '00:00:00'}  
              </h2>
              <button className='medium border-0 rounded-circle p-0 bg-transparent d-inline-block' onClick={()=>{handleEndVideo(data._id)}}>
             <img src="/assets/images/call-end.svg" width="30" height="30"/>
              </button> 
                </div>
             
             
<div className="dropdown">
  <button
    className="btn bg-transparent py-0 px-2  dropdown-toggle"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
  <i className="ri-more-2-fill fs-5 text-white"/>
  </button>
  <div className="dropdown-menu p-2">
 <h4 className='fs-6 pb-2 border-bottom'> 🧾 Patient Details </h4>
     <p className="fs-6 mb-1 bg-light p-1 border text-dark" > 🛠️ : {data?.orderId?.addProduct[0]?.title} </p>

 <p className="fs-6 mb-1" > 👤 :  {data?.receiver?.username || 'NA'} </p>
  <p className="fs-6 mb-1" > 📞 : <a href={`tel:${data?.receiver?.phone || ''}`} className='text-success'> {data?.receiver?.phone || 'NA'}  </a></p>
  
 <Link to={`/video-call?videoId=${data._id}`} className="btn-primary btn-sm w-100 d-block text-center"> Join Video Call</Link>

  </div>
</div>



            </div>


              </div>


          ))}
        </div>
      )}
    </>
  );
};

export default LiveVideoCall;
